export const CALENDAR_READING_PANE = 'CalendarEventReadingPane';
export const CALENDAR_READING_PANE_HEADER = 'CalendarEventReadingPaneHeader';
export const CALENDAR_READING_PANE_BODY = 'CalendarEventReadingPaneBody';
export const CALENDAR_EVENT_CAPTURE = 'CalendarEventCapture';
export const WORKSPACE_BOOKING_FULL_CAPTURE = 'WorkspaceBookingFullCapture';
export const CALENDAR_EVENT_QUICK_CAPTURE = 'CalendarEventQuickCapture';
export const CALENDAR_DAY_VIEW_ALL_DAY_WELL = 'CalendarDayViewAllDayWell';
export const CALENDAR_AGENDA_VIEW = 'CalendarAgendaView';
export const CALENDAR_SURFACE_VIEW = 'CalendarSurfaceView';
export const CALENDAR_READING_PANE_ATTENDEES_SPOKE = 'CalendarEventReadingPaneAttendeesSpoke';
export const AGENDA_VIEW_HEADER = 'AgendaViewHeader';
export const DAY_VIEW_HEADER = 'DayViewHeader';
export const DAY_VIEW_TAP = 'DayViewTap';
export const DAY_VIEW_LONG_PRESS = 'DayViewLongPress';
export const WORKSPACE_BOOKING_QUICK_CAPTURE = 'WorkspaceBookingQuickCapture';
export const EVENT_TYPE_SELECTOR = 'EventTypeSelector';
